/* [EZ] Collection Index — scrollspy nav (active follows scroll) + product-card colour-pill
   image swap. Source ref: ezviz.com/category. */
(function () {
  document.querySelectorAll('[data-ez-collindex]').forEach(function (root) {
    /* ---------- scrollspy nav ---------- */
    var navLinks = root.querySelectorAll('.ez-collindex__nav a[data-nav]');
    var secs = root.querySelectorAll('[data-sec]');
    var navWrap = root.querySelector('[data-collindex-navwrap]');
    var navTrigger = root.querySelector('[data-collindex-trigger]');
    var navCurrent = root.querySelector('[data-collindex-current]');

    function setActive(id) {
      navLinks.forEach(function (a) {
        var on = a.getAttribute('data-nav') === id;
        a.classList.toggle('is-active', on);
        if (on && navCurrent) navCurrent.textContent = a.textContent.trim();
      });
    }
    function closeNav() {
      if (navWrap) navWrap.classList.remove('is-open');
      if (navTrigger) navTrigger.setAttribute('aria-expanded', 'false');
    }

    // Mobile dropdown: label shows the active section; tap toggles the list; tap-out closes.
    if (navCurrent) {
      var act0 = root.querySelector('.ez-collindex__nav a.is-active') || navLinks[0];
      if (act0) navCurrent.textContent = act0.textContent.trim();
    }
    if (navTrigger && navWrap) {
      navTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = navWrap.classList.toggle('is-open');
        navTrigger.setAttribute('aria-expanded', String(open));
      });
      document.addEventListener('click', function (e) {
        if (!navWrap.contains(e.target)) closeNav();
      });
    }

    if (navLinks.length && secs.length && 'IntersectionObserver' in window) {
      var visible = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible[e.target.getAttribute('data-sec')] = e.isIntersecting ? e.intersectionRatio : 0; });
        // activate the section currently nearest the top band that is in view
        var bestId = null, bestTop = Infinity;
        secs.forEach(function (s) {
          if (visible[s.getAttribute('data-sec')]) {
            var top = Math.abs(s.getBoundingClientRect().top);
            if (top < bestTop) { bestTop = top; bestId = s.getAttribute('data-sec'); }
          }
        });
        if (bestId) setActive(bestId);
      }, { rootMargin: '-30% 0px -60% 0px', threshold: [0, 0.01] });
      secs.forEach(function (s) { io.observe(s); });
    }

    // smooth-scroll on nav click (+ immediate active state)
    navLinks.forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('data-nav');
        var target = root.querySelector('[data-sec="' + id + '"]');
        if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); setActive(id); closeNav(); }
      });
    });

    /* ---------- filter/sort bar: auto-submit the GET form on change ---------- */
    var tools = root.querySelector('.ez-collindex__toolsform');
    if (tools) {
      tools.addEventListener('change', function (e) {
        // Price inputs do NOT auto-submit on change/blur — they submit via the inline "Go"
        // button, so entering a min and tabbing to max no longer triggers a premature reload.
        if (e.target && e.target.closest('.ez-search__facet-menu--price')) return;
        if (tools.requestSubmit) tools.requestSubmit();
        else tools.submit();
      });

      // Price inputs: accept numbers only (digits + a single decimal point) — strip
      // letters, 'e', '+/-' and extra dots so only a clean value is submitted to Shopify.
      tools.querySelectorAll('.ez-search__facet-menu--price input').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var v = inp.value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
          if (inp.value !== v) inp.value = v;
        });
      });
    }

    /* ---------- product-card colour-pill image swap ---------- */
    root.querySelectorAll('[data-product-card]').forEach(function (card) {
      var img = card.querySelector('[data-card-img]');
      var swatches = card.querySelectorAll('.ez-pcard__swatch, .ez-pcard__pill');
      var buy = card.querySelector('[data-pcard-buy]');
      var idInput = card.querySelector('[data-pcard-id]');
      var atc = card.querySelector('[data-pcard-atc]');
      var priceEl = card.querySelector('.ez-pcard__price');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (x) { x.classList.remove('is-active'); });
          sw.classList.add('is-active');
          var src = sw.getAttribute('data-swatch-img');
          if (src && img) { img.setAttribute('src', src); img.removeAttribute('srcset'); }

          // Reflect the selected variant's price.
          var price = sw.getAttribute('data-variant-price');
          if (price && priceEl) priceEl.textContent = price;

          // Make the selected variant the one that gets added / bought, and reflect its stock.
          var vid = sw.getAttribute('data-variant-id');
          var avail = sw.getAttribute('data-available') === 'true';
          if (vid) {
            if (idInput) idInput.value = vid;
            if (buy) buy.setAttribute('data-ez-buy-now', vid);
          }
          if (sw.hasAttribute('data-available')) {
            if (buy) buy.classList.toggle('is-hidden', !avail);
            if (atc) {
              atc.disabled = !avail;
              atc.classList.toggle('ez-pcard__atc--soon', !avail);
              atc.textContent = avail ? 'Add to Cart' : 'Coming Soon';
            }
          }
        });
      });
    });
  });

  /* Add to Cart (AJAX) is now handled globally in ez-cart-drawer.js (loaded site-wide via the
     header), so it works on every page — collection cards, [EZ] Tabbed Products, etc. */
})();
